"use client";

import { Button, Icon } from "@kyan/ui";

import { useHandleLogOut } from "#/hooks/useHandleLogOut";

export const Disconnect: React.FC = () => {
  const { handleLogOut } = useHandleLogOut();

  return (
    <Button className="gap-1.5" variant="secondary" onClick={handleLogOut}>
      <Icon name="exit" />
      Disconnect
    </Button>
  );
};
